<html>

    <head>
        <link rel="stylesheet" type="text/css" href="https://cdn3.devexpress.com/jslib/23.1.3/css/dx-gantt.css" />   
    </head>

    <body class="dx-viewport">
       
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->  
        <dx-box
            direction="row"
            width="100%"
            [height]="formheight"
        >
            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
            <dxi-item
                [ratio]="2.5"
            >
                <dx-gantt 
                    #gridtodotask
                    id="gridtodotask"
             
                    [taskListWidth]="400"
                   
                    height="98%"
                    width="100%"

                    scaleType="months"

                    [showRowLines]="true"

                    [(selectedRowKey)]="selectedRowKey"

                    [startDateRange]="ganttstartdate"
                    [endDateRange]="ganttenddate"

                    (onSelectionChanged)="OnSelectionChanged($event)"

                    (onTaskInserting)="onTaskInserting($event)"
                    (onTaskInserted)="onTaskInserted($event)"
                    (onTaskUpdated)="onTaskUpdated($event)"
                    (onTaskDeleting)="onTaskDeleted($event)"

                    (onDependencyInserted)="onDependencyInserted($event)"
                    (onDependencyDeleted)="onDependencyDeleted($event)"

                    (onTaskEditDialogShowing)="onTaskEditDialogShowing($event)"

                    taskContentTemplate="taskContentTemplate"

                    taskTooltipContentTemplate="taskTooltipContentTemplate"

                    taskTimeTooltipContentTemplate="myTaskTimeTooltipTemplate"
                >
                    <dxo-tasks 
                        [dataSource]="subscriptiontodolist"

                        KeyExpr="id"
                        TitleExpr="title"
                        ParentIdExpr="parentId"
                        StartExpr="start"
                        EndExpr="end"
                        ProgressExpr="progress"
                        BudgetExpr="budget"
                        ActualExpr="actual"
                        ParenttaskidExpr="parenttaskid"
                    > 
                    </dxo-tasks>

                    <dxo-dependencies 
                        [dataSource]="subscriptiontodolistdependencylist"
                    >
                    </dxo-dependencies>

                    <dxo-filter-row 
                        [visible]="true"
                    ></dxo-filter-row>

                    <dxi-column 
                        dataField="title" 
                        caption="Task Description" 
                        [width]="200"
                    >
                    </dxi-column>

                    <dxi-column 
                        dataField="start" 
                        dataType="date"
                        caption="Start Date" 
                        [format]="dateformat"
                        [width]="75"
                    >
                    </dxi-column>

                    <dxi-column 
                        dataField="end" 
                        dataType="date"
                        caption="End Date" 
                        [format]="dateformat"
                        [width]="75"
                    >
                    </dxi-column>

                    <dxi-column 
                        dataField="progress" 
                        [width]="100"
                        [visible]="false"
                    >
                    </dxi-column>

                    <dxi-column 
                        dataField="budget" 
                        [width]="100"
                        [visible]="false"
                    >
                    </dxi-column>

                    <dxi-column 
                        dataField="actual" 
                        [width]="100"
                        [visible]="false"
                    >
                    </dxi-column>

                    <dxi-column 
                        dataField="parenttaskid" 
                        [width]="100"
                        [visible]="false"
                    >
                    </dxi-column>

                    <dxi-column 
                        dataField="taskconfirm" 
                        [width]="100"
                        [visible]="false"
                    >
                    </dxi-column>
                    <!------------------------------------------------------------------------->
                    <dxi-column 
                        type="buttons" 
                        [width]="50"
                        
                    >
                        <dxi-button
                            id="btnscheduler"
                            hint="Click here to create/update/delete appointments"
                            icon="fa-sharp fa-regular fa-calendar-days"
                            [onClick]="schedulerclick"
                        >
                        </dxi-button>

                        <dxi-button
                            id="btnservice"
                            hint="Click here to create & update collaborators details need for the tasks"
                            icon="fa-solid fa-magnifying-glass-plus"
                            [onClick]="serviceclick"     
                        >
                        </dxi-button>
                    
                    </dxi-column>
                    <!------------------------------------------------------------------------->
                    <dxo-editing 
                        [enabled]="true"
                    >
                    </dxo-editing>
                    <!------------------------------------------------------------------------->
                    <dxo-toolbar>
                        <dxi-item name="collapseAll"></dxi-item>
                        <dxi-item name="expandAll"></dxi-item>
                        <dxi-item name="separator"></dxi-item>
                        <dxi-item name="addTask"></dxi-item>
                        <dxi-item name="separator"></dxi-item>
                        <dxi-item name="showDependencies"></dxi-item>
                        <dxi-item name="separator"></dxi-item>
                        <dxi-item name="zoomIn"></dxi-item>
                        <dxi-item name="zoomOut"></dxi-item>
                    </dxo-toolbar>
                    <!----------------------------template for the Gantt Tasks--------------------------------------------->
                    <div *dxTemplate="let item of 'taskContentTemplate'"  class="custom-task"

                        [style.width.px]="item.taskSize.width" 
                    >
                
                        <img [src]="" [id]="'taskid' + item.taskData.id" />
                     
                        <div class="custom-task-wrapper">
                            <div class="custom-task-title">{{item.taskData.title}}</div>
                         </div>

                        <div
                            class="custom-task-progress"
                            style.width="{{ item.taskData.progress }}%"
                        >
                        </div>
                    
                    </div>
                    <!-----------------------------ToolTip template for the Gantt Task-------------------------------------------->
                    <div *dxTemplate="let task of 'taskTooltipContentTemplate'" class="custom-tooltip" >
                        Task:<span style="text-decoration-line: underline">{{ task.title }} </span> &nbsp;&nbsp; Progress: {{ task.progress }}&nbsp;%
                        <br>
                            Start Date: {{task.start | date: this.dateformat }} &nbsp;&nbsp; End Date: {{task.end | date: this.dateformat }}
                        <br>
                            Days Total: {{ task.start| nodaydiff: task.end: 1 }} &nbsp;&nbsp;
                            Days Remaining: {{ todayDate| nodaydiff: task.end: 1 }}          
                        <br>
                            Budget:&nbsp;&nbsp;{{ task.budget }} &nbsp;&nbsp; Actual:&nbsp;&nbsp; {{task.actual}}
                    </div>
                    <!----------------------------template for the Gantt Task -> Start & End Dates--------------------------------------------->
                    <div *dxTemplate="let item of 'myTaskTimeTooltipTemplate'" class="custom-tasksdateedate">
                            Start: {{item.start | date: this.dateformat }} &nbsp;&nbsp; End: {{item.end | date: this.dateformat }}
                        <br>
                            Days Tot: {{ item.start| nodaydiff: item.end: 1 }} &nbsp; Days Rem: {{ todayDate| nodaydiff: item.end: 1 }}   
                       
                    </div>
                    <!------------------------------------------------------------------------->
                </dx-gantt>

            </dxi-item>
            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
        </dx-box>
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
        <dx-popup
            [(title)] = "popuptitle"
            [hideOnOutsideClick]="false"
            [(visible)]="popuptaskdetailVisible"
            height="65%"
            width="32%"
            position="center"
        >
            <!------------------------------------------------------------------------->
            <dxi-toolbar-item
                widget="dxButton"
                location="after"
                toolbar="bottom"

                [options]="{
                                text: 'Save',
                                type: 'success',
                                onClick: saveClick
                            }"

            >
            </dxi-toolbar-item>

            <dxi-toolbar-item
                widget="dxButton"
                location="after"
                toolbar="bottom"

                [options]="{
                                text: 'Cancel',
                                onClick: cancelClick
                            }"

            >
            </dxi-toolbar-item>

            
            <!------------------------------------------------------------------------->
            <div *dxTemplate="let data of 'content'" style="width: 100%;">
                <!------------------------------------------------------------------------->
                <dx-form 
                    #formtodotask
                    [(formData)]="formData"

                    height="65%"
                   
                    [showColonAfterLabel]="true"  
                    labelMode="floating"
                    labelLocation="left"
                    colCount="2"
                >
                    <!------------------------------------------------------------------------->
                    <dxi-item 
                        itemType="group" 
                        caption="Task Details"
                        [colCount]="2"
                    >
                        <dxi-item
                            dataField="title"
                            colSpan="1"
                            [editorOptions]="{  
                                                width: '50%',
                                                placeholder: 'Enter Task Description', 
                                                inputAttr: { autocomplete: 'chrome-off'}
                                            }"

                        >
                            <dxo-label 
                                text="Task Description"
                            >
                            </dxo-label>  
                            
                            <dxi-validation-rule
                                type="required"
                                message="Task Description is required"
                            >
                            </dxi-validation-rule>
                            
                        </dxi-item>

                        <dxi-item
                            dataField="taskconfirm"
                            dataType="boolean"
                            editorType="dxCheckBox"
                            colSpan="1"

                            [editorOptions]="{  
                                                width: '10%'
                                             }"
                        >
                            <dxo-label 
                                text="Task Status"
                            >
                            </dxo-label>  
                            
                            <dxi-validation-rule type="custom" 
                                [validationCallback]="checkBoxValidationCallback">
                            </dxi-validation-rule>
                            
                        </dxi-item>

                    </dxi-item>
                    <!------------------------------------------------------------------------->
                    <dxi-item itemType="empty" [colSpan]="2"></dxi-item>
                    <!------------------------------------------------------------------------->
                    <dxi-item 
                        itemType="group" 
                        caption="Task Dates"
                        [colCount]="2"
                    >

                        <dxi-item
                            dataField="start"
                            dataType="date"
                            [colSpan]="1" 
                            [editorOptions]="{   
                                                width: '50%',
                                                placeholder: 'Enter Task Start Date', 
                                                inputAttr: { autocomplete: 'chrome-off'}
                                            }"

                        >
                            <dxo-label 
                                text="Start Date"
                            >
                            </dxo-label> 
                            
                            <dxi-validation-rule
                                type="custom"
                                [reevaluate]="true"
                                [validationCallback]="validstartdateinput" 
                                [message]="startdateinputvalmsg"
                            >
                            </dxi-validation-rule> 

                        </dxi-item>

                        <dxi-item
                            dataField="end"
                            dataType="date"
                            [colSpan]="1" 
                            [editorOptions]="{   
                                                placeholder: 'Enter Task End Date', 
                                                inputAttr: { autocomplete: 'chrome-off'}
                                            }"

                        >
                            <dxo-label 
                                text="End Date"
                            >
                            </dxo-label>  
                            
                            <dxi-validation-rule
                                type="custom"
                                [reevaluate]="true"
                                [validationCallback]="validenddateinput" 
                                [message]="enddateinputvalmsg"
                            >
                            </dxi-validation-rule> 

                        </dxi-item>

                    </dxi-item>
                    <!------------------------------------------------------------------------->
                    <dxi-item itemType="empty" [colSpan]="2"></dxi-item>
                    <!------------------------------------------------------------------------->
                    <dxi-item 
                        itemType="group" 
                        caption="Financial Details"
                        [colCount]="2"
                    >

                        <dxi-item
                            dataField="budget"
                            dataType="number"
                            [colSpan]="1" 
                            [disabled]="true"
                            [editorOptions]="{   
                                                width: '50%',
                                                placeholder: 'Enter Budget Amount', 
                                                inputAttr: { autocomplete: 'chrome-off'}
                                            }"
                        >
                            <dxo-label 
                                text="Budget"
                            >
                            </dxo-label>    
                            
                            <dxi-validation-rule
                                type="custom"
                                [reevaluate]="true"
                                [validationCallback]="validbudgetinput" 
                                [message]="budgetinputvalmsg"
                            >
                            </dxi-validation-rule>

                        </dxi-item>

                        <dxi-item
                            dataField="actual"
                            dataType="number"
                            [colSpan]="1" 
                            [disabled]="true"
                            [editorOptions]="{   
                                                placeholder: 'Enter Actual Amount', 
                                                inputAttr: { autocomplete: 'chrome-off'}
                                            }"
                        >
                            <dxo-label 
                                text="Actual"
                            >
                            </dxo-label>    
                            
                            <dxi-validation-rule
                                type="required"
                                message="Actual is required"
                            >
                            </dxi-validation-rule>

                        </dxi-item>

                    </dxi-item>
                    <!------------------------------------------------------------------------->
                    <dxi-item itemType="empty" [colSpan]="2"></dxi-item>
                    <!------------------------------------------------------------------------->
                    <dxi-item
                        dataField="progress"
                        dataType="number"
                        colspan="2"
                        [editorOptions]="{  
                                            placeholder: 'Enter Progress', 
                                            inputAttr: { autocomplete: 'chrome-off'}
                                        }"

                    >
                        <dxo-label 
                            text="Progress"
                        >
                        </dxo-label>       
                        <!------------------------------------------------------------------------->
                        <div *dxTemplate>

                            <span style="font-size: 16">Progress</span>

                            <dx-slider 
                                #sliderprogress
                                [min]="0" 
                                [max]="100" 
                               
                                [(value)]="progress1" 
                                [rtlEnabled]="false"

                                [showRange]="true"
                            
                                (onValueChanged)="onValueChangedSlider($event)"
                            >
                                <dxo-label
                                    [visible]="true"
                                    [format]="sliderformat"
                                    position="top"
                                >
                                </dxo-label>
                                
                                <dxo-tooltip
                                    [enabled]="true"
                                    [format]="sliderformat"
                                    showMode="always"
                                    position="top"
                                ></dxo-tooltip>


                            </dx-slider>
                        </div>
                        <!------------------------------------------------------------------------->
                    </dxi-item>
                    

                </dx-form>

            </div>
            <!------------------------------------------------------------------------->

        </dx-popup>
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
        <dx-popup
            #popscheduler
            id="popscheduler"
            [width]="800"
            [height]="550"
            [showTitle]="true"
            title="Task Scheduler"
            [dragEnabled]="true"
            [hideOnOutsideClick]="false"
            [showCloseButton]="true"
        
            [(visible)]="popupscheduleVisible"
            (onShowing)="onShowingScheduler($event)"
        >
            <!------------------------------------------------------------------------->
            <dxo-position
                my="left top" 
                [of]="positionOf"
            >

                <dxo-offset
                    [x]="toastposX" 
                    [y]="toastposY"
                >
                </dxo-offset>

            </dxo-position>
            <!------------------------------------------------------------------------->
            <dx-box
                direction="row"
                width="100%"
                height="100%"
             >
                <!------------------------------------------------------------------------->
                <dxi-item
                    [ratio]="1.3"
                    class="rectangleinfosquare"
                >       
                         
                    <dx-scheduler
                        #scheduleragenda
                        id="scheduleagenda"

                        [dataSource]="subscriptionschedulerlist"

                        [views]="['agenda']"
                        currentView="agenda"
        
                        [startDayHour]="8"
                        height="98%"

                        (onContentReady)="onContentReadyAgenda($event)"
                        [customizeDateNavigatorText]="customizeAgendaDateNavigatorText"
                      
                        (onAppointmentTooltipShowing)="onAppointmentTooltipShowing($event, 1)"
                        (onAppointmentClick)="onAgendaAppointmentClick($event)"
                        (onAppointmentDblClick)="onAgendaAppointmentDblClick($event)"

                        appointmentTemplate="appointment-agendatemplate"
                    >
                       
                        <dxi-view
                            type="agenda"
                            [agendaDuration]="agendaageduration"
                            dateCellTemplate="agendadateCellTemplate"
                        
                        ></dxi-view>

                      
                        <div *dxTemplate="let data of 'agendadateCellTemplate'">
                            <div class="fontsize12">
                                {{data.date | date: 'EEEE' }} 
                                <br>
                                {{data.date | date: dateformat}}
                            </div>
                          
                        </div>

                        <div *dxTemplate="let modelagenda of 'appointment-agendatemplate'">

                            {{modelagenda.targetedAppointmentData.title}}
                            <br>
                            {{modelagenda.targetedAppointmentData.startDate | date:'shortTime'}}-{{modelagenda.targetedAppointmentData.endDate | date:'shortTime'}}
                          
                        </div>

                    </dx-scheduler>
                    
                </dxi-item>
                <!------------------------------------------------------------------------->
                <dxi-item
                    [ratio]="0.008"
                >
                </dxi-item> 




                <dxi-item
                    [ratio]="2.5"
                    class="rectangleinfosquare"
                >       
                    
                    <dx-scheduler
                        #scheduler
                        id="scheduler"

                        [dataSource]="subscriptionschedulerlist"

                        [views]="['day', 'week','month']"
                        [(currentView)]="scheduleview"

                        [currentDate]="currentDate"
                      
                        [startDayHour]="8"
                        height="98%"

                        (onAppointmentFormOpening)="onAppointmentFormOpening($event)"

                        (onAppointmentAdding)="onAppointmentAdding($event)"
                        (onAppointmentUpdated)="onAppointmentUpdated($event)"

                        appointmentTooltipTemplate="tooltip-template"
                    >   
                        <!------------------------------------------------------------------------->
                        <dxo-scrolling mode="virtual"> </dxo-scrolling>
                        <!------------------------------------------------------------------------->
                        <dxi-view
                            type="day"
                            appointmentTemplate="appointmentday-template"
                        >
                        </dxi-view>

                        <dxi-view
                            type="week"
                            appointmentTemplate="appointmentweek-template"
                            dateCellTemplate="dateCellWeekTemplate"
                        >
                        </dxi-view>

                        <dxi-view
                            type="month"
                            appointmentTemplate="appointmentmonth-template"
                        >
                        </dxi-view>
                        <!------------------------------------------------------------------------->
                        <div *dxTemplate="let data of 'appointmentday-template'"  style="width: 100%">

                            <div style="display: flex">

                                <div style="border: 2px solid white; width: 60%; margin-right: 2px;">
                                    <dx-text-box
                                        label="Subject"
                                        [readOnly]="true"
                                        [value]="data.appointmentData.title"
                                        
                                        width="98%"
                                        height="20px"
                                    >
                                    </dx-text-box>

                                </div>

                                <div style="border: 2px solid white; width: 35%">

                                    <dx-text-box
                                            label="Time"
                                            [readOnly]="true"
                                            value="{{data.targetedAppointmentData.startDate | date:'shortTime'}}-{{data.targetedAppointmentData.endDate | date:'shortTime'}}"
                                            width="98%"
                                            height="20px"
                                    >
                                    </dx-text-box>

                                </div>

                                <div>
                                    <dx-button
                                        icon="trash"
                                        stylingMode="text"
                                        [elementAttr]="{ class: 'elementright' }"
                                        (onClick)="onDeleteButtonClick($event,  data.appointmentData)"
                                    >
                                    </dx-button>
                                </div>

                            </div>

                        </div>
                        <!------------------------------------------------------------------------->
                        <div *dxTemplate="let data of 'appointmentweek-template'">

                            <div style="font-size:9px;">
                                {{data.targetedAppointmentData.startDate | date:'shortTime'}} -
                                <br>
                                {{data.targetedAppointmentData.endDate | date:'shortTime'}}
                            </div>
                          
                        </div>

                        <div *dxTemplate="let data of 'dateCellWeekTemplate'">

                            <div style="font-size:10px;">
                                {{data.date | date: 'EEEE' }} 
                                <br>
                                {{data.date | date: dateformat}}
                            </div>
                          
                        </div>
                        <!------------------------------------------------------------------------->
                        <div *dxTemplate="let data of 'appointmentmonth-template'">

                            <div style="font-size:8px;">
                                {{data.targetedAppointmentData.startDate | date:'shortTime'}}
                                <br>
                                {{data.targetedAppointmentData.endDate | date:'shortTime'}}
                            </div>

                        </div>
                        <!------------------------------------------------------------------------->
                        <div *dxTemplate="let data of 'tooltip-template'" style="width: 100%;">

                            <div style="display: flex;">

                                <div class="scheduleSubject">
                                    <dx-text-box
                                        label="Subject"
                                        [readOnly]="true"
                                        [value]="data.appointmentData.title"
                                        width="90%"
                                        height="20px"
                                    >
                                    </dx-text-box>
                                </div>
                                <!------------------------------------------------------------------------->
                                <ng-container>
                                    <div *ngIf="scheduleview != 'day'; then thenBlock"></div>

                                    <ng-template #thenBlock>   
                                        <div>

                                            <dx-button
                                                icon="trash"
                                                stylingMode="text"
                                                (onClick)="onDeleteButtonClick($event,  data.appointmentData)"
                                            ></dx-button>

                                        </div>

                                    </ng-template>    

                                </ng-container>
                                <!------------------------------------------------------------------------->
                            </div>

                            <div class="scheduleToolTip">

                                <dx-text-area
                                    label="Notes"
                                    [(value)]="data.appointmentData.description"
                                    [autoResizeEnabled]="false"
                                    width="100%"
                                    [readOnly]="true"
                                >
                                </dx-text-area>
                            </div>
                            

                        </div>
                        <!------------------------------------------------------------------------->

                    </dx-scheduler>

                </dxi-item>

            </dx-box>
            <!------------------------------------------------------------------------->
        </dx-popup>
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
        <dx-popup
            #popservice
            id="popservice"
            [width]="800"
            [height]="550"
            [showTitle]="true"
            title="Services"
            [dragEnabled]="true"
            [hideOnOutsideClick]="false"
            [showCloseButton]="true"

            [(visible)]="popupserviceVisible"
            
            (onShowing)="onShowingCollaborator($event)"
        >
            <!------------------------------------------------------------------------->
            <dxo-position
                my="left top" 
                [of]="positionOf"
            >
                <dxo-offset
                    [x]="toastposX" 
                    [y]="toastposY"
                >
                </dxo-offset>
            </dxo-position>
            <!------------------------------------------------------------------------->
            <dx-box
                direction="row"
                width="100%"
                height="100%"
            >
                <!------------------------------------------------------------------------->
                <dxi-item
                    [ratio]="5" 
                >     

                    <dx-box
                            direction="col"
                            width="100%"
                            height="100%"
                    >

                        <dxi-item
                            [ratio]="5"
                        >

                            <dx-data-grid 
                                #grideventcollaborator
                                id="grideventcollaborator"

                                keyExpr="id"

                                [dataSource]="subscriptioncollaboratorlist" 
                                noDataText="No Collaborator Listed"   

                                [allowColumnReordering]="false"
                                [allowColumnResizing]="true"
                                [showRowLines]="true"
                                [showColumnLines]="false"
                                [showBorders]="true"
                                [repaintChangesOnly]="true"

                                [focusedRowEnabled]="true"
                                [hoverStateEnabled]="true"
                                [autoNavigateToFocusedRow]="true"

                                (onCellPrepared)="datagrideditorPreparing( $event )" 
                                (onRowClick)="onrowCollaboratorclick($event)"
                                (onFocusedRowChanged)="onrowCollaboratorchange($event)"

                                (onCellHoverChanged)="onCellHoverCollaborator($event)"

                                width="100%"
                                height="98%"
                            >
                                <!------------------------------------------------------------------------->
                                <dxo-filter-row
                                    [visible]="false"
                                >
                                </dxo-filter-row>

                                <dxo-sorting
                                    mode="single"> <!-- or "multiple" | "none" -->
                                </dxo-sorting>

                                <dxo-selection
                                    mode="single"
                                >
                                </dxo-selection>

                                <dxo-load-panel
                                    [enabled]="false">
                                </dxo-load-panel>

                                <dxo-editing 
                                    mode="popup"                            
                                    [allowUpdating]="true"
                                    [allowDeleting]="true"
                                    [allowAdding]="true"
                                    [useIcons]="true"
                                >
                                </dxo-editing>
                                <!------------------------------------------------------------------------->
                                <dxi-column
                                    dataField="id"
                                    caption="id"
                                    [allowEditing]="false" 
                                    [allowSorting]="false"
                                    [visible]="false"
                                    width="0%"
                                >
                                </dxi-column>   

                                <dxi-column
                                    dataField="providername"
                                    caption="Collaborator"
                                    [allowEditing]="true" 
                                    [allowSorting]="false"
                                    [visible]="true"
                                    width="26%"
                                >

                                    <dxi-validation-rule 
                                        type="required"
                                        message="Please Enter Collaborator">
                                    </dxi-validation-rule>

                                </dxi-column>   

                                <dxi-column
                                    dataField="contactperson"
                                    caption="Contact/Person Name"
                                    [allowEditing]="true" 
                                    [allowSorting]="false"
                                    [visible]="true"
                                    width="26%"

                                    headerCellTemplate="contactpersonHeaderTemplate"
                                >
                                </dxi-column>

                                <div *dxTemplate="let info of 'contactpersonHeaderTemplate'">
                                    Contact Person / 
                                    <br>
                                    Name Person
                                </div>

                                <dxi-column
                                    dataField="mobile"
                                    caption="Mobile"
                                    [allowEditing]="true" 
                                    [allowSorting]="false"
                                    [visible]="true"
                                    width="22%"
                                >
                                </dxi-column>

                                <dxi-column
                                    dataField="budget"
                                    caption="Budget"
                                    [allowEditing]="true" 
                                    [allowSorting]="false"
                                    [visible]="true"
                                    width="15%"
                                >
                                </dxi-column>

                                <dxi-column
                                    dataField="amount"
                                    caption="Actual"
                                    [allowEditing]="true" 
                                    [allowSorting]="false"
                                    [visible]="true"
                                    width="15%"
                                >
                                </dxi-column>

                                <dxi-column
                                    dataField="statuslist"
                                    caption="Status"
                                    [allowEditing]="true" 
                                    [allowSorting]="false"
                                    [visible]="true"
                                    width="11%"
                                    cellTemplate="cellStatusIcon"
                                >

                                    <div *dxTemplate="let data of 'cellStatusIcon'">

                                        <container-element [ngSwitch]="data.value">

                                            <div *ngSwitchCase="'Listed'"><i class="fa-regular fa-circle-question fa-2x center"></i></div>

                                            <div *ngSwitchCase="'Shortlist'"><i class="fa-regular fa-circle-dot fa-2x center"></i></div>

                                            <div *ngSwitchCase="'Confirm'"><i class="fa-regular fa-circle-check fa-2x center"></i></div>

                                        </container-element>
                                        
                                    </div>

                                </dxi-column>

                                <dxi-column 
                                    type="buttons" 
                                    [width]="50"
                                    
                                >
                                    <dxi-button
                                        id="btncostallocation"
                                        hint="Click here to allocate cost"
                                        icon="fa-sharp fa-regular fa-calendar-days"
                                        [onClick]="collaboratorcostallocclick"
                                    >
                                    </dxi-button>

                                </dxi-column>
                                <!------------------------------------------------------------------------->
                                <dxo-toolbar>
                                    <dxi-item location="after">
                                        <div *dxTemplate>

                                            <dx-button
                                                text="Add"
                                                icon="refresh" 
                                                (onClick)="collaboratorform( $event, 10)"
                                            >

                                            </dx-button>

                                            <dx-button
                                                text="Edit"
                                                icon="refresh" 
                                                [disabled]="buttondisable"
                                                (onClick)="collaboratorform( $event, 20)"
                                            >
                                            </dx-button>
                                        </div>
                                    </dxi-item>
                                </dxo-toolbar>
                                <!------------------------------------------------------------------------->
                            </dx-data-grid>

                        </dxi-item>
                        <!------------------------------------------------------------------------->
                        <dxi-item
                            [ratio]="0.05" 
                        >  
                    
                        </dxi-item>
                        <!------------------------------------------------------------------------->
                        <dxi-item
                            [ratio]="3"
                            class="rectangleinfosquare"
                        >

                            {{collabcost}}

                            <ng-template [ngIf]="statusflag == 'Confirm'">

                                <div>Content to render when condition is true.</div>

                                <dx-data-grid 
                                    #gridealloccost
                                    id="gridealloccost"

                                    [dataSource]="organisercostallocation"
                                    keyExpr="id"

                                    width="70%"
                                    height="87%"
                                    
                                    [repaintChangesOnly]="true"

                                    (onRowUpdated)="updateShareCost($event)"
                                >
                                    <!------------------------------------------------------------------------->
                                    <dxo-editing 
                                        mode="row"                            
                                        [allowUpdating]="true"
                                        [allowDeleting]="false"
                                        [allowAdding]="false"
                                        [useIcons]="true"
                                    >
                                    </dxo-editing>
                                    <!------------------------------------------------------------------------->
                                    <dxo-summary [calculateCustomSummary]="calculateShareCostSummary">

                                        <dxi-total-item
                                            column="percallocation"
                                            displayFormat="% Total: {0}"
                                            summaryType="sum"
                                        >
                                        </dxi-total-item>

                                        <dxi-total-item
                                            name="ShareCostSummary"
                                            summaryType="custom"
                                            showInColumn="Your Share"
                                            displayFormat="$ Total: {0}"
                                        >
                                        </dxi-total-item>

                                    </dxo-summary> 
                                    <!------------------------------------------------------------------------->
                                    <dxi-column
                                        dataField="id"
                                        caption="id"
                                        [allowEditing]="false" collaboratorform
                                        [allowSorting]="false"
                                        [visible]="true"
                                        width="20%"

                                        cellTemplate="cellparticipantname"
                                    >

                                         <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->    
                                        <div *dxTemplate="let d of 'cellparticipantname'">
                                            <div>{{whoseguest | getinitial: d.value: whoseguest.length: 1 }}</div> 
                                        </div>  
                                        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx--> 
                                    </dxi-column> 


                                    <dxi-column
                                        dataField="confirmcost"
                                        caption="Cost Amount"
                                        [allowEditing]="false" 
                                        [allowSorting]="false"
                                        [visible]="false"
                                        width="30%"
                                    >
                                    </dxi-column>

                                    <dxi-column
                                        datafield="calcsharecost"
                                        caption="Your Share"
                                        [allowEditing]="false" 
                                        [allowSorting]="false"
                                        [visible]="true"
                                        width="30%"

                                        [calculateCellValue]="ShareCost"
                                    >
                                    </dxi-column>

                                    
                                    <dxi-column
                                        dataField="percallocation"
                                        caption="% of Cost"
                                        [allowEditing]="true" 
                                        [allowSorting]="false"
                                        [visible]="true"
                                        width="20%"

                                        [setCellValue]="SetShareCost"
                                    >
                                    </dxi-column> 

                                </dx-data-grid>

                            </ng-template>
                            
                        </dxi-item>
                        <!------------------------------------------------------------------------->
                    </dx-box>
                    <!------------------------------------------------------------------------->

                </dxi-item>
                <!------------------------------------------------------------------------->
                <dxi-item
                    [ratio]="0.05" 
                >  
                    
                </dxi-item>
                <!------------------------------------------------------------------------->
                <dxi-item
                    [ratio]="2.5"
                    class="rectangleinfosquare"      
                >     
                    <dx-box
                        direction="col"
                        width="100%"
                        height="60%"
                    >
                        <!------------------------------------------------------------------------->
                        <dxi-item
                            [ratio]="1"
                        >   

                            <dx-box
                                direction="row"
                                width="100%"
                                height="100%"
                            >

                                <dxi-item
                                    [ratio]="1"
                                >   
                                    <div class="paddmargin10">Phone:</div>
                                </dxi-item>

                                <dxi-item
                                    [ratio]="3"
                                    class="rectangleinfo"      
                                >   
                                    <div>{{collaboratordetails[0].phone}}</div>
                                </dxi-item>
                            </dx-box>

                        </dxi-item>
                        <!------------------------------------------------------------------------->
                        <dxi-item
                            [ratio]="0.05" 
                        >  
                        
                        </dxi-item>
                        <!------------------------------------------------------------------------->
                        <dxi-item
                            [ratio]="1" 
                        >

                            <dx-box
                                direction="row"
                                width="100%"
                                height="100%"
                            >
                                <dxi-item
                                    [ratio]="1"
                                >   
                                    <div class="paddmargin10">Email:</div>
                                </dxi-item>

                                <dxi-item
                                    [ratio]="3"
                                    class="rectangleinfo"      
                                >   
                                    <div>{{collaboratordetails[0].email}}</div>
                                </dxi-item>
                            </dx-box>

                        </dxi-item>
                        <!------------------------------------------------------------------------->
                        <dxi-item
                            [ratio]="0.05" 
                        >  
                        
                        </dxi-item>
                        <!------------------------------------------------------------------------->
                        <dxi-item
                            [ratio]="1"    
                        >   

                            <dx-box
                                direction="row"
                                width="100%"
                                height="100%"
                            >
                                <dxi-item
                                    [ratio]="1"
                                >   
                                    <div class="paddmargin10">Street:</div>
                                </dxi-item>

                                <dxi-item
                                    [ratio]="3"
                                    class="rectangleinfo"      
                                >   
                                    <div>{{collaboratordetails[0].street}}</div>
                                </dxi-item>
                            </dx-box>

                        </dxi-item>
                        <!------------------------------------------------------------------------->
                        <dxi-item
                            [ratio]="0.05" 
                        >  
                    
                        </dxi-item>
                        <!------------------------------------------------------------------------->
                        <dxi-item
                            [ratio]="1"   
                        >  
                        
                            <dx-box
                                direction="row"
                                width="100%"
                                height="100%"
                            >
                                <dxi-item
                                    [ratio]="1"
                                >   
                                    <div class="paddmargin10">Suburb:</div>
                                </dxi-item>

                                <dxi-item
                                    [ratio]="3"
                                    class="rectangleinfo"      
                                >   
                                    <div>{{collaboratordetails[0].suburb}} {{collaboratordetails[0].postcode}}</div>
                                </dxi-item>
                            </dx-box>
                            
                        </dxi-item>
                        <!------------------------------------------------------------------------->
                        <dxi-item
                            [ratio]="0.05" 
                        >  
                    
                        </dxi-item>
                        <!------------------------------------------------------------------------->
                        <dxi-item
                            [ratio]="4"
                           
                        >   

                            <dx-box
                                direction="row"
                                width="100%"
                                height="100%"
                            >
                                <dxi-item
                                    [ratio]="1"
                                >   
                                    <div class="paddmargin10">Notes:</div>
                                </dxi-item>

                                <dxi-item
                                    [ratio]="3"
                                    class="rectangleinfo"      
                                >   

                                    <dx-text-area
                                        [(value)]="collaboratordetails[0].notes"
                                        [autoResizeEnabled]="false"
                                        width="100%"
                                        height="95%"
                                        [readOnly]="true"
                                        >
                                     </dx-text-area>
                                   
                                </dxi-item>

                            </dx-box>

                        </dxi-item>
                        <!------------------------------------------------------------------------->

                    </dx-box>

                </dxi-item>
                <!------------------------------------------------------------------------->
            </dx-box>
            <!------------------------------------------------------------------------->
        </dx-popup>
        <!--xxxxxxxxxxxxxxxxxxxxxxCOLLABORATOR POPUPxxxxxxxxxxXxxxxxxxxxxxxx-->
        <dx-popup
            id="popupformcollaborator"
            [(title)] = "popuptitle"
            [hideOnOutsideClick]="false"
            [(visible)]="popupcollaboratorVisible"
            height="78%"
            width="35%"
        >
            <!------------------------------------------------------------------------->
            <dxo-position
                at="left top"
            >
                <dxo-offset
                    [x]="400" 
                    [y]="280"
                >
                </dxo-offset>
            </dxo-position>
            <!------------------------------------------------------------------------->
            <dxi-toolbar-item
                widget="dxButton"
                location="after"
                toolbar="bottom"

                [options]="{
                                text: 'Save',
                                type: 'success',
                                onClick: saveCollaboratorClick
                            }"

            >
            </dxi-toolbar-item>

            <dxi-toolbar-item
                widget="dxButton"
                location="after"
                toolbar="bottom"

                [options]="{
                                text: 'Cancel',
                                onClick: cancelCollaboratorClick
                            }"

            >
            </dxi-toolbar-item>
            <!------------------------------------------------------------------------->
            <dx-form 
                #formcollaborator
                [(formData)]="formcollaboratorData"
            
                [showColonAfterLabel]="true"  
                labelMode="outside"
                labelLocation="top"

                (onFieldDataChanged)="formCollaboratorDatafldchange( $event )"
                
                [colCount]="3"
            >
                <!------------------------------------------------------------------------->
                <dxi-item
                    dataField="statuslist"
                    editorType ="dxSelectBox"
                   
                    [editorOptions]="{  width: 180, 
                                        height: 40, 
                                        placeholder: 'Enter Status', 
                                        inputAttr: { autocomplete: 'chrome-off'},
                                        items: this.collaboratorstatus, value: this.selcollaboratorstatus
                                    }"
                >      
                    <dxo-label 
                        template="name"
                        text="Status"
                    >
                    </dxo-label>

                    <dxi-validation-rule
                        type="custom"
                        [reevaluate]="true"
                        [validationCallback]="validcollabstatus" 
                        [message]="collabstatusinputvalmsg"
                    >
                    </dxi-validation-rule> 

                </dxi-item>
                <!------------------------------------------------------------------------->
                <dxi-item
                    dataField="budget"
                    editorType="dxNumberBox"
                    [editorOptions]="{  width: 150, 
                                        height: 40, 
                                        placeholder: 'Enter Budget Cost', 
                                        inputAttr: { autocomplete: 'chrome-off'}
                                    }"
                >
                    <dxo-label 
                        template="name"
                        text="Budget Cost"
                    >
                    </dxo-label>     

                    <dxi-validation-rule
                        type="custom"
                        [reevaluate]="true"
                        [validationCallback]="validbudgetinput" 
                        [message]="budgetinputvalmsg"
                    >
                    </dxi-validation-rule>

                </dxi-item>
                <!------------------------------------------------------------------------->
                <dxi-item
                    dataField="amount"
                    editorType="dxNumberBox"
                    [editorOptions]="{  width: 150, 
                                        height: 40, 
                                        placeholder: 'Enter Actual Cost', 
                                        inputAttr: { autocomplete: 'chrome-off'}
                                    }"
                >
                    <dxo-label 
                        template="name"
                        text="Actual Cost"
                    >
                    </dxo-label>     

                    <dxi-validation-rule
                        type="custom"
                        [reevaluate]="true"
                        [validationCallback]="validbudgetinput" 
                        [message]="budgetinputvalmsg"
                    >
                    </dxi-validation-rule>

                </dxi-item>
                <!------------------------------------------------------------------------->
                <dxi-item itemType="empty" [colSpan]="3"></dxi-item>
                <!------------------------------------------------------------------------->
                <dxi-item 
                    itemType="group" 
                    caption="Collaborator"
                    [colCount]="3"
                   
                >
                    <dxi-item
                        dataField="providername"
                 
                        [editorOptions]="{  width: 165, 
                                            height: 40, 
                                        
                                            placeholder: 'Enter Collaborator', 
                                            inputAttr: { autocomplete: 'chrome-off'}
                                        }"
                    >

                        <dxo-label 
                            template="name"
                            text="Collaborator Name"
                        >
                        </dxo-label>      

                        <dxi-validation-rule 
                            type="required"
                            message="Collaborator is required"
                        >
                        </dxi-validation-rule>

                    </dxi-item>

                    <dxi-item
                        dataField="contactperson"
                      
                        [editorOptions]="{  width: 150, 
                                            height: 40, 
                                            placeholder: 'Enter Contact Person', 
                                            inputAttr: { autocomplete: 'chrome-off'}
                                        }"
                    >
                        <dxo-label 
                            template="name"
                            text="Contact Person"
                        >
                        </dxo-label>     

                    </dxi-item>

                    <dxi-item
                        dataField="mobile"

                        [editorOptions]="{  width: 145, 
                                            height: 40, 
                                            placeholder: 'Enter Mobile', 
                                            inputAttr: { autocomplete: 'chrome-off'}
                                        }"
                    >

                        <dxo-label 
                            template="mobile"
                            text="MOB"
                        >
                        </dxo-label>     

                    </dxi-item>

                    <dxi-item
                        dataField="phone"

                        [editorOptions]="{  width: 165, 
                                            height: 40, 
                                            placeholder: 'Enter Phone', 
                                            inputAttr: { autocomplete: 'chrome-off'}
                                        }"
                    >

                        <dxo-label 
                            template="mobile"
                            text="Phone"
                        >
                        </dxo-label>     

                    </dxi-item>

                    <dxi-item
                        dataField="email"
                        [colSpan]="2"
                        [editorOptions]="{  width: 300, 
                                            height: 40, 
                                            placeholder: 'Enter Email', 
                                            inputAttr: { autocomplete: 'chrome-off'}
                                        }"
                    >

                        <dxi-validation-rule
                            type="email"
                            message="Email is invalid"
                        >
                        </dxi-validation-rule>

                        <dxo-label 
                            template="mobile"
                            text="Email"
                        >
                        </dxo-label>     

                    </dxi-item>

                    <dxi-item
                        dataField="notes"
                        editorType="dxTextArea"
                        [colSpan]="3"
                        [editorOptions]="{  width: 470, 
                                            height: 50, 
                                            placeholder: 'Enter Notes', 
                                            inputAttr: { autocomplete: 'chrome-off'}
                                        }"

                    >
                        <dxo-label 
                            template="note"
                            text="Notes"
                        >
                        </dxo-label>    
                    </dxi-item>

                </dxi-item>
                <!------------------------------------------------------------------------->
                <dxi-item itemType="empty" [colSpan]="3"></dxi-item>
                <dxi-item itemType="empty" [colSpan]="3"></dxi-item>
                <dxi-item itemType="empty" [colSpan]="3"></dxi-item>
                <!------------------------------------------------------------------------->
                <dxi-item 
                    itemType="group" 
                    caption="Address"
                    [colCount]="4"
               
                >
                    <dxi-item
                        dataField="street"
                
                        [editorOptions]="{  width: 130, 
                                            height: 40, 
                                            placeholder: 'Enter Street', 
                                            inputAttr: { autocomplete: 'chrome-off'}
                                        }"
                    >
                        <dxo-label 
                            template="name"
                            text="street"
                        >
                        </dxo-label>     

                    </dxi-item>

                    <dxi-item
                        dataField="suburb"
                
                        [editorOptions]="{  width: 115, 
                                            height: 40, 
                                            placeholder: 'Enter Suburb', 
                                            inputAttr: { autocomplete: 'chrome-off'}
                                        }"
                    >
                        <dxo-label 
                            template="name"
                            text="Suburb"
                        >
                        </dxo-label>     

                    </dxi-item>

                    <dxi-item
                        dataField="state"
                
                        [editorOptions]="{  width: 113, 
                                            height: 40, 
                                            placeholder: 'Enter State', 
                                            inputAttr: { autocomplete: 'chrome-off'}
                                        }"
                    >
                        <dxo-label 
                            template="name"
                            text="Suburb"
                        >
                        </dxo-label>     

                    </dxi-item>

                    <dxi-item
                        dataField="postcode"
                
                        [editorOptions]="{  width: 100, 
                                            height: 40, 
                                            placeholder: 'Enter Postcode', 
                                            inputAttr: { autocomplete: 'chrome-off'}
                                        }"
                    >
                        <dxo-label 
                            template="name"
                            text="Postcode"
                        >
                        </dxo-label>     

                    </dxi-item>

                </dxi-item>
                <!------------------------------------------------------------------------->
                <ng-container *ngFor="let label of labelTemplates">
                    <div *dxTemplate="let data of label.name">
                      <div><i class="dx-icon {{ label.icon }}"></i>{{ data.text }}</div>
                    </div>
                </ng-container>
                <!------------------------------------------------------------------------->
            </dx-form>
            <!------------------------------------------------------------------------->
        </dx-popup>
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
        <dx-toast
            [(message)]       =   "toastFileMessage"
            [(visible)]       =   "toastVisible"
            [type]            =   "toasttypeerror"
            [displayTime]     =   "toastdisplaytime"  
            [width]           =   "toastwidth" 
        >
                        
            <dxo-position>

                <dxo-at 
                    x="left" 
                    y="top">
                </dxo-at>

                <dxo-offset
                    [x]="180" 
                    [y]="20"
                >
                </dxo-offset>
                
            </dxo-position>

        </dx-toast>
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
    </body>
    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
</html>
